// extracted by mini-css-extract-plugin
export default {"backButtonRow":"PanelHeader_backButtonRow__n401p","backButton":"PanelHeader_backButton__PGFXX"};